import {
  required as requiredValidator,
  requiredIf as requiredIfValidator,
  email as emailValidator,
  sameAs as sameAsValidator,
  helpers,
} from "@vuelidate/validators";
import type { MaybeRef } from "vue";

export const required = ( msg: string ) => helpers.withMessage( msg, requiredValidator );

export const email = ( msg: string ) => helpers.withMessage( msg, emailValidator );

export const requiredIf = ( msg: string, prop: MaybeRef<boolean> | string | ( ()=> boolean | Promise<boolean> ) ) => helpers.withMessage( msg, requiredIfValidator( prop ) );

export const sameAs = ( msg: string, equalTo: MaybeRef<boolean> | string | ( ()=> boolean | Promise<boolean> ) ) => helpers.withMessage( msg, sameAsValidator( equalTo ) );
